module.exports = __webpack_public_path__ + "wildcard.png?6e9a6cad68556b8670032c406b55c61c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wildcard.png
// module id = 73
// module chunks = 0